import React from 'react';
import ImageAnswerTranslationItem from "../../Data/ImageAnswerTranslationItem";
import HeaderAnswerTranslationItem from "../../Data/HeaderAnswerTranslationItem";

export interface HeaderAnswerProps {
    headerAnswerData?: HeaderAnswerTranslationItem,
    nameValue: string,
    onClick?: () => void,
    onKeyPressEnter?: (event : any) => void,
    shouldShow?: boolean | null,
    selected?: boolean | null
}
const tabIndex = 0;

export const HeaderAnswerComponent: React.FC<HeaderAnswerProps> = ({headerAnswerData, nameValue, onClick, onKeyPressEnter, shouldShow, selected}) => {
    if(!headerAnswerData) return <></>;
    if(shouldShow === false) return <></>;
    //
    return (
        <div className={"zoopass--header-answer-wrapper col radio"}>
            <div className={"h-100 radio radio--wrapped radio--white mx-2" + (selected ? " selected" : "")}>
            <label onClick={onClick} onKeyPressCapture={onKeyPressEnter} className="h-100 d-inline-flex d-md-flex zoopass--selectable radio__label-content" tabIndex={tabIndex}>
                <input type="radio" name={nameValue} tabIndex={tabIndex} className="order-0 order-md-last d-none"/>
                <div className="d-block my-4 mx-1 w-100">
                    <h5 className="h1 text--0 d-none d-md-block w-100 text-center px-1">{headerAnswerData.headerText}</h5>
                    {headerAnswerData.title == null ? ('') : (<h6 className="w-100 text-center px-1">{headerAnswerData.title}</h6>)}
                    {headerAnswerData.description == null ? ('') : (<p className="w-100 text-center px-1" dangerouslySetInnerHTML={{__html: headerAnswerData.description}}></p>)}
                </div>
            </label>
            </div>
        </div>
    );
}
